// The columns the Accelerator's own reads and writes ask for (data.js), in 1 place, so the tests
// replay exactly these (tests/e2e/fixtures/accelerator/print-sql.mjs records the same, and the
// replay answers only these). docs/data-model.md 10.6.1 is the contract. Pure: no imports.
export const ACC_PRODUCT = '10000000-0000-4000-8000-000000000002'

// the member's goal, their months of actions and their wins: their own rows only (row level
// security; the person viewed as, for staff viewing as), filtered to them as well, so an owner who
// also has the Accelerator never reads anyone else's
export const GOAL_COLUMNS = 'id, body, status, locked_at, updated_at'
export const CYCLE_COLUMNS = 'id, month, session_id, started_at, closed_at'
export const ACTION_COLUMNS = 'id, cycle_id, body, sort_order, done_at, member_note, note_at, carried_over_from_id'
// created_by_kind: whether the member logged the win, so Edit and Delete show only on theirs (Adam, 7 Oct)
export const WIN_COLUMNS = 'id, title, category, win_date, detail, shareable, created_by_kind, created_at'
